// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "3.71.5/styles/main.bundle.css";
	// return url for filenames based on template
	return "3.71.5/styles/" + "videojs" + ".chunk.css?" + "d8361e05ec9c31356b0d" + "";
};